// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__mPOmq","image":"Header_image__afmLR","name":"Header_name__1UwcW","info":"Header_info__2JzWz","infoRow":"Header_infoRow__30joU"};